export interface CausaOrigenItem {
  pregunta: string;
  respuesta: string;
}

export interface ResolucionEstructurada {
  resolucion: string;
  causas: CausaOrigenItem[];
}

/**
 * Caracteres que admite cada porqué. Es el tope de guardaDetalles.do
 * (ResolucionPorquesSupport.MAXIMO_CARACTERES_PORQUE): se cambian juntos.
 */
export const LIMITE_PORQUE = 100;

const ENCABEZADO_RESOLUCION = "Resolución:\n";
const SEPARADOR_CAUSA_ORIGEN = "\n\nCausa / Origen:\n";

export function parsearResolucionEstructurada(
  descripcion?: string | null,
): ResolucionEstructurada | null {
  const valor = (descripcion || "").replaceAll("\r\n", "\n").trim();
  if (!valor.startsWith(ENCABEZADO_RESOLUCION)) {
    return null;
  }

  const indiceCausa = valor.indexOf(SEPARADOR_CAUSA_ORIGEN);
  if (indiceCausa === -1) {
    return null;
  }

  const resolucion = valor
    .slice(ENCABEZADO_RESOLUCION.length, indiceCausa)
    .trim();
  const bloques = valor
    .slice(indiceCausa + SEPARADOR_CAUSA_ORIGEN.length)
    .split(/\n\n(?=\d+\.\s)/);
  const causas: CausaOrigenItem[] = [];

  for (let indice = 0; indice < bloques.length; indice++) {
    const coincidencia = bloques[indice].match(
      /^(\d+)\.\s+(\S.*|\s)\n[^\S\n]*Respuesta:\s+(\S.*|\s)$/s,
    );
    if (!coincidencia || Number(coincidencia[1]) !== indice + 1) {
      return null;
    }

    causas.push({
      pregunta: coincidencia[2].trim(),
      respuesta: coincidencia[3].trim(),
    });
  }

  return resolucion && causas.length >= 5 ? { resolucion, causas } : null;
}

export function preguntaPorque(porques: string[], indice: number): string {
  if (indice === 0) {
    return "¿Por qué ocurrió la incidencia?";
  }

  return `¿Por qué ${quitarPrefijoPorque(porques[indice - 1])}?`;
}

export function quitarPrefijoPorque(valor?: string | null): string {
  return (valor || "")
    .trim()
    .replace(/^(por\s+qu[eé]|porque)\s+/i, "")
    .trim();
}
